import { defineMessages } from '@jutro/locale';

export default defineMessages({

    PolicyCoveragesHeader: {
        id: 'ml.gateway.views.AccountClaims.PolicyCoverages.Coverages',
        defaultMessage: 'Coverages'
    },
    deductible: {
        id: 'ml.gateway.views.AccountClaims.PolicyCoverages.Deductible',
        defaultMessage: '{amount} deductible'
    },
    policyDetails: {
        id: 'ml.gateway.views.AccountClaims.PolicyCoverages.POLICY DETAILS',
        defaultMessage: 'POLICY DETAILS'
    },
    policyNumber: {
        id: 'ml.gateway.views.AccountClaims.PolicyCoverages.Policy Number',
        defaultMessage: 'Policy #{number} ({state})'
    },
    vehicles: {
        id: 'ml.gateway.views.AccountClaims.PolicyCoverages.VEHICLES',
        defaultMessage: 'VEHICLES'
    }

});
